import React from 'react'

const PosterDesigns = () => {
  return (
    <div>PosterDesigns</div>
  )
}

export default PosterDesigns